import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email, password);
      navigate(user.role === "admin" ? "/admin" : "/contul-meu");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bubble-bg flex min-h-[80vh] items-center justify-center px-6 py-16" data-testid="login-page">
      <div className="w-full max-w-md rounded-3xl border border-slate-100 bg-white p-8 shadow-[0_8px_40px_rgba(2,132,199,0.08)]">
        <h1 className="font-display text-3xl font-black tracking-tight text-slate-900">Bine ai revenit</h1>
        <p className="mt-2 text-slate-500">Autentifică-te în contul tău Mimaso.</p>

        {error && <div className="mt-5 rounded-lg bg-red-50 px-4 py-3 text-sm text-red-600" data-testid="login-error">{error}</div>}

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" data-testid="login-email" required />
          </div>
          <div>
            <Label htmlFor="password">Parolă</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" data-testid="login-password" required />
          </div>
          <Button type="submit" size="lg" disabled={loading} className="w-full rounded-full bg-sky-600 hover:bg-sky-500" data-testid="login-submit">
            {loading ? "Se autentifică..." : "Autentificare"}
          </Button>
        </form>

        <p className="mt-6 text-center text-sm text-slate-500">
          Nu ai cont? <Link to="/inregistrare" className="font-semibold text-sky-600 hover:underline">Creează unul</Link>
        </p>
      </div>
    </div>
  );
}
